export default "__VITE_ASSET__3d83493f__"